import {Injectable,Inject} from 'ng-metadata/core';
import {PrimoResponse} from '../../infra/dataStructures/PrimoResponses/doc.interfcae';

import {getInstitutionCode,getCurrentPCKey, getVid} from '../../appConfig/appConfigForward';

import {JwtUtilService} from '../../security/jwtUtil.service';
import {ConfigurationUtil} from "../../nddUtils/configurationUtil.service";

const map= require('lodash/map');
const get= require('lodash/get');

@Injectable()
export class TimesCitedService {


    private  _citedData:Object[];
    private showTimesCitedForSuprima:boolean;

    constructor(private jwtUtilService:JwtUtilService,
                @Inject('$http') private $http : ng.IHttpService,
                @Inject('$stateParams')  private $stateParams:ng.ui.IStateParamsService,
                @Inject('restBaseURLs') private restBaseURLs,
                 private configurationUtil: ConfigurationUtil ){}


    get citedData(): Object {
        return this._citedData;
    }

    set citedData(value: Object) {
        this._citedData = value;
    }

    public containsInArr(arr:string[], elem:string):boolean{
        for(let temp of arr){
            if(temp === elem){
                return true;
            }
        }
        return false;
    }

    get inFrbrMode():boolean{
        let facet = this.$stateParams["facet"];
        if(facet == undefined){
            return false;
        }
        if (facet instanceof Array) {
            for(let temp of facet){
                if(temp.startsWith("frbrgroupid,")){
                    return true;
                }
            }
            return false;
        }
        else{
            return facet.startsWith("frbrgroupid,")? true:false;
        }


    }

    public updateCitedTimesAvailability(record: PrimoResponse.IExtendedDoc) {
        this.citedData= undefined;
        let control = record.pnx.control;
        if(this.configurationUtil.isSuprima()){
            if(record['adaptor'] !== 'Primo Central'){
                return;
            }
        }
        let facetType = get(record, 'pnx.facets.frbrtype');

        if(!(this.containsInArr(control['sourceid'], 'scopus') ||  this.containsInArr(control['sourceid'],'wos'))
             && (facetType== 6 || this.inFrbrMode)) {
            return;
        }
        let pnxData = [];
        let recordId = record.pnx.control.recordid;
        let facetGroupId = get(record, 'pnx.facets.frbrgroupid');
        let timesCitedFromPnx = get(record, 'extras.timesCited');

        facetType = map(facetType, n => n == 5 ? 7 : n)
        let citedData = {
            "recordid": recordId,
            "facetGroupid": facetGroupId,
            "facetType": facetType,
            "timesCited": timesCitedFromPnx
        };

        pnxData.push(citedData);
        let institutionCode = getInstitutionCode();
        let pcKey = getCurrentPCKey();
        let signedIn = this.isSignedIn()
        let serverData = { "institutionCode" :institutionCode, "signedIn" : signedIn , "recordsPnx": pnxData, "pcKey":pcKey}
        if (this.configurationUtil.isSuprima()) {
        	serverData["vid"] =  getVid();
        }
        let promise = this.$http.post(this.restBaseURLs.timesCited, serverData);
        promise.then(response => {
                     this.addDataToDoc(response.data)});

    }


    public addDataToDoc(linksJson){
                if (!linksJson){
                    return;
                }
                this.citedData = linksJson;
    }







     public isSignedIn(){
         return this.jwtUtilService.isSignedIn();
     }

    get shouldDisplayTimesCited() {
        return !(this.citedData == undefined || (Array.isArray(this.citedData) && !this.citedData.length));
    }

    public isShowTimesCitedForSuprima(){
       return this.showTimesCitedForSuprima;
    }

    public setShowTimesCitedForSuprima(showTimesCitedForSuprimaArg:boolean){
       this.showTimesCitedForSuprima =  showTimesCitedForSuprimaArg;
    }

}



// WEBPACK FOOTER //
// ./src/main/webapp/components/search/timesCited/timesCited.service.ts